import UserDetailView from './UserDetailView';

export default UserDetailView;
